// extracted by mini-css-extract-plugin
module.exports = {"TitleWrapper":"Title_TitleWrapper__1mPX3","Title":"Title_Title__3ulLb","inverse":"Title_inverse__36afp","TitleInner":"Title_TitleInner__3XUSc"};